query isStockPhotoLicensed($input: IsStockPhotoLicensedInput!) {
  isStockPhotoLicensed(input: $input) {
    url
    license
    isLicensed
  }
}
